module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.classes,
    style: (_vm.stylesIcon)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e097bec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/icon.vue
// module id = 399
// module chunks = 0